import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../application/core/DispatchProps';
import UserLogoutRequested from '../application/user/events/UserLogoutRequested';

class Logout extends React.PureComponent<DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new UserLogoutRequested());
    }

    public render(): null {
        return null;
    }
}

export default connect(mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/view/Logout.tsx